import { render, staticRenderFns } from "./SchemaField.vue?vue&type=template&id=27d67d13&"
import script from "./SchemaField.vue?vue&type=script&lang=js&"
export * from "./SchemaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports